// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faq {
  padding: 2.5rem 6.875rem;
  display: flex;
  justify-content: space-between;
}
@media (max-width: 768px) {
  .faq {
    padding: 0 1rem;
    flex-direction: column;
  }
}
.faq__title {
  font-size: 2.5rem;
  line-height: 3.25rem;
  font-weight: 600;
  color: rgba(var(--grey-900));
}
@media (max-width: 768px) {
  .faq__title {
    font-size: 1.75rem;
    line-height: 2rem;
  }
}
.faq__spinner {
  margin: 5rem auto;
}
.faq__subtitle {
  font-family: var(--merriweather);
  font-weight: 300;
  line-height: 1.625;
  color: rgba(var(--grey-600));
  margin-top: 1.25rem;
}
@media (max-width: 768px) {
  .faq__subtitle {
    font-size: 0.875rem;
    line-height: 1.375rem;
    margin-top: 0.5rem;
  }
}
.faq__line {
  margin-top: 2rem;
}
@media (max-width: 768px) {
  .faq__line {
    margin-top: 1rem;
  }
}

.faq-list {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-left: 4rem;
  width: 60%;
}
@media (max-width: 768px) {
  .faq-list {
    margin-left: 0;
    margin-top: 1.5rem;
    width: 100%;
    gap: 0.5rem;
  }
}
.faq-list__item {
  cursor: pointer;
}
@media (max-width: 768px) {
  .faq-list__item {
    margin-top: 1rem;
  }
}
.faq-list__item-content {
  margin-right: 3rem;
}
@media (max-width: 768px) {
  .faq-list__item-content {
    margin-right: 1rem;
  }
}
.faq-list__item-title {
  font-size: 1.25rem;
  line-height: 2rem;
  font-weight: 500;
  color: rgba(var(--grey-800));
  white-space: pre-line;
}
@media (max-width: 768px) {
  .faq-list__item-title {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.faq-list__item-description {
  font-family: var(--merriweather);
  font-weight: 300;
  line-height: 1.625;
  color: rgba(var(--grey-600));
  margin-top: 0.5rem;
}
@media (max-width: 768px) {
  .faq-list__item-description {
    font-size: 0.875rem;
    line-height: 1.375rem;
  }
}

.faq-icon {
  position: relative;
  min-width: 2rem;
}
.faq-icon > div {
  position: absolute;
}`, "",{"version":3,"sources":["webpack://./src/components/FAQ/styles.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,aAAA;EACA,8BAAA;AACF;AACE;EALF;IAMI,eAAA;IACA,sBAAA;EAEF;AACF;AAAE;EACE,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,4BAAA;AAEJ;AAAI;EANF;IAOI,kBAAA;IACA,iBAAA;EAGJ;AACF;AAAE;EACE,iBAAA;AAEJ;AACE;EACE,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,4BAAA;EACA,mBAAA;AACJ;AACI;EAPF;IAQI,mBAAA;IACA,qBAAA;IACA,kBAAA;EAEJ;AACF;AACE;EACE,gBAAA;AACJ;AACI;EAHF;IAII,gBAAA;EAEJ;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,UAAA;AACF;AACE;EAPF;IAQI,cAAA;IACA,kBAAA;IACA,WAAA;IACA,WAAA;EAEF;AACF;AAAE;EACE,eAAA;AAEJ;AAAI;EAHF;IAII,gBAAA;EAGJ;AACF;AADI;EACE,kBAAA;AAGN;AADM;EAHF;IAII,kBAAA;EAIN;AACF;AADI;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;EACA,qBAAA;AAGN;AADM;EAPF;IAQI,eAAA;IACA,mBAAA;EAIN;AACF;AADI;EACE,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,4BAAA;EACA,kBAAA;AAGN;AADM;EAPF;IAQI,mBAAA;IACA,qBAAA;EAIN;AACF;;AACA;EACE,kBAAA;EACA,eAAA;AAEF;AAAE;EACE,kBAAA;AAEJ","sourcesContent":[".faq {\n  padding: 2.5rem 6.875rem;\n  display: flex;\n  justify-content: space-between;\n\n  @media (max-width: 768px) {\n    padding: 0 1rem;\n    flex-direction: column;\n  }\n\n  &__title {\n    font-size: 2.5rem;\n    line-height: 3.25rem;\n    font-weight: 600;\n    color: rgba(var(--grey-900));\n\n    @media (max-width: 768px) {\n      font-size: 1.75rem;\n      line-height: 2rem;\n    }\n  }\n\n  &__spinner {\n    margin: 5rem auto;\n  }\n\n  &__subtitle {\n    font-family: var(--merriweather);\n    font-weight: 300;\n    line-height: 1.625;\n    color: rgba(var(--grey-600));\n    margin-top: 1.25rem;\n\n    @media (max-width: 768px) {\n      font-size: 0.875rem;\n      line-height: 1.375rem;\n      margin-top: 0.5rem;\n    }\n  }\n\n  &__line {\n    margin-top: 2rem;\n\n    @media (max-width: 768px) {\n      margin-top: 1rem;\n    }\n  }\n}\n\n.faq-list {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  margin-left: 4rem;\n  width: 60%;\n\n  @media (max-width: 768px) {\n    margin-left: 0;\n    margin-top: 1.5rem;\n    width: 100%;\n    gap: 0.5rem;\n  }\n\n  &__item {\n    cursor: pointer;\n\n    @media (max-width: 768px) {\n      margin-top: 1rem;\n    }\n\n    &-content {\n      margin-right: 3rem;\n\n      @media (max-width: 768px) {\n        margin-right: 1rem;\n      }\n    }\n\n    &-title {\n      font-size: 1.25rem;\n      line-height: 2rem;\n      font-weight: 500;\n      color: rgba(var(--grey-800));\n      white-space: pre-line;\n\n      @media (max-width: 768px) {\n        font-size: 1rem;\n        line-height: 1.5rem;\n      }\n    }\n\n    &-description {\n      font-family: var(--merriweather);\n      font-weight: 300;\n      line-height: 1.625;\n      color: rgba(var(--grey-600));\n      margin-top: 0.5rem;\n\n      @media (max-width: 768px) {\n        font-size: 0.875rem;\n        line-height: 1.375rem;\n      }\n    }\n  }\n}\n\n.faq-icon {\n  position: relative;\n  min-width: 2rem;\n\n  > div {\n    position: absolute;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
